import { render, staticRenderFns } from "./PromptView.vue?vue&type=template&id=1765bc54&scoped=true&"
import script from "./PromptView.vue?vue&type=script&lang=js&"
export * from "./PromptView.vue?vue&type=script&lang=js&"
import style0 from "./PromptView.vue?vue&type=style&index=0&id=1765bc54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1765bc54",
  null
  
)

export default component.exports